'use client';

import { useEffect, useState } from 'react';

import {
  UPLIFT_SPAM_BLOCKED_EVENT,
  UPLIFT_SPAM_MESSAGE,
} from '@/config/spamList';
import {
  UPLIFT_WIDGET_SCRIPT_ID,
  UPLIFT_WIDGET_SCRIPT_SRC,
} from '@/config/uplift.config';
import {
  installUpliftTracker,
  setUpliftWidgetGuid,
} from '@/utils/upliftTracker';

import styles from './upliftWidget.module.scss';

type UpliftWidgetProps = {
  guid: string;
  tall?: boolean;
};

const UpliftWidget = ({ guid, tall = false }: UpliftWidgetProps) => {
  const [spamBlocked, setSpamBlocked] = useState(false);

  useEffect(() => {
    const onSpamBlocked = () => setSpamBlocked(true);
    window.addEventListener(UPLIFT_SPAM_BLOCKED_EVENT, onSpamBlocked);

    // Must be installed before the widget script runs, so no request is missed
    installUpliftTracker();
    setUpliftWidgetGuid(guid);

    const existing = document.getElementById(
      UPLIFT_WIDGET_SCRIPT_ID
    ) as HTMLScriptElement | null;

    if (!existing) {
      const js = document.createElement('script');
      js.id = UPLIFT_WIDGET_SCRIPT_ID;
      js.src = `${UPLIFT_WIDGET_SCRIPT_SRC}?guid=${guid}`;

      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(js, firstScript);
    } else {
      const currentGuid = new URL(existing.src).searchParams.get('guid');
      if (currentGuid && currentGuid !== guid) {
        window.location.reload();
      }
    }

    return () => {
      window.removeEventListener(UPLIFT_SPAM_BLOCKED_EVENT, onSpamBlocked);
    };
  }, [guid]);

  return (
    <div className={styles.shell}>
      <widget-search
        className={`${styles.widget}${tall ? ` ${styles.widgetTall}` : ''}`}
      />
      {spamBlocked && (
        <div className={styles.spamNotice} role="alert">
          {UPLIFT_SPAM_MESSAGE}
        </div>
      )}
    </div>
  );
};

export default UpliftWidget;
